package com.klantenstop.web.pages.admin

import com.klantenstop.web.data.models.domain.toModerationEntry
import com.klantenstop.web.data.repos.ModerationRepo
import com.materialkobweb.utils.ViewModel
import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.SharedFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asSharedFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

class AdminHomeViewModel(
    private val moderationRepo: ModerationRepo = ModerationRepo,
) : ViewModel(), AdminHomeContract {

    private val _state = MutableStateFlow(AdminHomeContract.State())
    override val state: StateFlow<AdminHomeContract.State> = _state.asStateFlow()

    private val _effect = MutableSharedFlow<AdminHomeContract.Effect>()
    override val effect: SharedFlow<AdminHomeContract.Effect> = _effect.asSharedFlow()

    init {
        sendIntent(AdminHomeContract.Intent.LoadModerationQueues)
    }

    override fun sendIntent(intent: AdminHomeContract.Intent) = coroutineScope.launch {
        when (intent) {
            is AdminHomeContract.Intent.LoadModerationQueues -> loadModerationQueues()
        }
    }

    override fun emitEffect(effect: AdminHomeContract.Effect) = coroutineScope.launch {
        _effect.emit(effect)
    }

    override fun updateState(block: (AdminHomeContract.State) -> AdminHomeContract.State) {
        _state.update(block)
    }

    private fun loadModerationQueues() {
        coroutineScope.launch { loadCompanyQueue() }
        coroutineScope.launch { loadStatusQueue() }
        coroutineScope.launch { loadReviewQueue() }
    }

    private suspend fun loadCompanyQueue() {
        updateState { it.copy(isLoadingCompanies = true, companyError = null) }
        try {
            val queueDto = moderationRepo.getCompanyQueue(page = 1, pageSize = 5)
            updateState {
                it.copy(
                    companyItems = queueDto.items.map { dto -> dto.toModerationEntry() },
                    companyTotal = queueDto.total,
                    isLoadingCompanies = false
                )
            }
        } catch (e: Exception) {
            updateState { it.copy(isLoadingCompanies = false, companyError = e.message) }
        }
    }

    private suspend fun loadStatusQueue() {
        updateState { it.copy(isLoadingStatuses = true, statusError = null) }
        try {
            val queueDto = moderationRepo.getStatusQueue(page = 1, pageSize = 5)
            updateState {
                it.copy(
                    statusItems = queueDto.items.map { dto -> dto.toModerationEntry() },
                    statusTotal = queueDto.total,
                    isLoadingStatuses = false
                )
            }
        } catch (e: Exception) {
            updateState { it.copy(isLoadingStatuses = false, statusError = e.message) }
        }
    }

    private suspend fun loadReviewQueue() {
        updateState { it.copy(isLoadingReviews = true, reviewError = null) }
        try {
            val queueDto = moderationRepo.getReviewQueue(page = 1, pageSize = 5)
            updateState {
                it.copy(
                    reviewItems = queueDto.items.map { dto -> dto.toModerationEntry() },
                    reviewTotal = queueDto.total,
                    isLoadingReviews = false
                )
            }
        } catch (e: Exception) {
            updateState { it.copy(isLoadingReviews = false, reviewError = e.message) }
        }
    }
}
